export default __webpack_public_path__ + "static/media/chat-connect-gray.7a0fec9b.svg";